var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bell',{attrs:{"mode":"events"}}),_c('bell',{attrs:{"mode":"notifications"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }